export default "__VITE_ASSET__BBi_WqXF__"